import {
  BarChart3,
  Bookmark,
  DollarSign,
  Package,
  Receipt,
  ShoppingCart,
  Sparkles,
  UserPlus,
  Users,
  type LucideIcon,
} from 'lucide-react';

export interface KpiTheme {
  gradient: string; // clases tailwind from-/to-
  Icon: LucideIcon;
}

// Gradientes vivos de 3 stops (diagonal) — más saturados, como el original.
export const KPI_THEME: Record<string, KpiTheme> = {
  sales: { gradient: 'from-red-500 via-red-600 to-rose-700', Icon: DollarSign },
  orders: { gradient: 'from-sky-400 via-blue-500 to-blue-700', Icon: ShoppingCart },
  products: { gradient: 'from-emerald-400 via-emerald-500 to-teal-700', Icon: Package },
  avgTicket: { gradient: 'from-amber-400 via-orange-500 to-orange-600', Icon: Receipt },
  newClients: { gradient: 'from-violet-400 via-violet-500 to-purple-700', Icon: UserPlus },
  clientsNew: { gradient: 'from-cyan-400 via-teal-500 to-emerald-600', Icon: Sparkles },
  clientsCabin: { gradient: 'from-indigo-400 via-indigo-500 to-blue-700', Icon: Users },
  layaways: { gradient: 'from-fuchsia-400 via-fuchsia-500 to-pink-600', Icon: Bookmark },
  layawaysVg: { gradient: 'from-fuchsia-400 via-fuchsia-500 to-pink-600', Icon: Bookmark },
  // Apartados SB: MISMO tema que Apartados (abonado).
  layawaysSb: { gradient: 'from-fuchsia-400 via-fuchsia-500 to-pink-600', Icon: Bookmark },
  // Total Ventas por-empresa: MISMO tema que Total Ventas (rojo).
  salesVg: { gradient: 'from-red-500 via-red-600 to-rose-700', Icon: DollarSign },
  salesPi: { gradient: 'from-red-500 via-red-600 to-rose-700', Icon: DollarSign },
  salesSb: { gradient: 'from-red-500 via-red-600 to-rose-700', Icon: DollarSign },
};

export const DEFAULT_KPI_THEME: KpiTheme = { gradient: 'from-slate-500 via-slate-600 to-slate-800', Icon: BarChart3 };

export function kpiTheme(metric: string | null | undefined): KpiTheme {
  return (metric && KPI_THEME[metric]) || DEFAULT_KPI_THEME;
}
